import React from 'react';

import '../icon-component.scss';

const TickComponent = () => (
  <svg className="icon-component" viewBox="0 0 31 28">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M9.8367128,0.211894666 C9.70405799,0.0702968087 9.54317875,0 9.35407509,0 C9.16497143,0 9.0040922,0.0702968087 8.87143739,0.211894666 L4.21534776,5.18890873 L2.12862179,2.95447445 C1.9969078,2.81287659 1.83602857,2.74257978 1.64692491,2.74257978 C1.45688043,2.74257978 1.2960012,2.81287659 1.1642872,2.95447445 L0.199011803,3.98482482 C0.0663569962,4.12642267 0.0005,4.29814773 0.0005,4.5 C0.0005,4.70185227 0.0663569962,4.87357733 0.199011803,5.01517518 L2.76743466,7.75775497 L3.73271006,8.78810533 C3.86536486,8.92970319 4.0262441,9 4.21534776,9 C4.40539223,9 4.56627147,8.92970319 4.69798546,8.78810533 L5.66326086,7.75775497 L10.8019882,2.2725954 C10.934643,2.13200179 11.0005,1.95927248 11.0005,1.75742022 C11.0005,1.55556795 10.934643,1.38384289 10.8019882,1.24224503 L9.8367128,0.211894666 Z" />
    </g>
  </svg>
);

TickComponent.displayName = 'TickIcon';

export default TickComponent;
